export const removeDefaultRole =(roles:string[])=>{
    if(!roles.length) return []
    const filterRoles= roles.filter((role: string) => role !== 'offline_access' && role !== 'default-roles-demo' && role !== 'uma_authorization');
    return filterRoles;
  }